import type { CreditTermBreachNotificationDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CreditTermBreachNotificationService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getNotificationHistory = (userId: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, CreditTermBreachNotificationDto[]>({
      method: 'GET',
      headers: { Accept: 'application/json' },
      url: `/api/app/credit-term-breach-notification/notification-history/${userId}`,
    },
    { apiName: this.apiName,...config });
}